<template>
  <m-base
    :showTopBorder="pattern.showTopBorder"
    :showRightBorder="pattern.showRightBorder"
    :showBottomBorder="pattern.showBottomBorder"
    :showLeftBorder="pattern.showLeftBorder"
    :showTopPadding="pattern.showTopPadding"
    :showRightPadding="pattern.showRightPadding"
    :showBottomPadding="pattern.showBottomPadding"
    :showLeftPadding="pattern.showLeftPadding"
    :showHeader="false"
    :showPadding="false"
    :showBorderRadius="pattern.showBorderRadius"
    :boxType="pattern.boxType"
  >
    <div slot="content" class="content">
      <video
        class="video"
        loop
        :poster="data.cover"
        :src="data.src"
        play-btn-position="center"
        show-mute-btn
        page-gesture
        controls
        muted
        x5-video-player-type="h5-page"
      />
    </div>
  </m-base>
</template>

<script>
import {
  mapState,
  mapMutations
} from 'vuex';
export default {
  props: {
    params: {
      type: Object,
      default: () => {
        return {
        }
      }
    },
    data: {
      type: Object,
      default: () => {
        return {
        }
      }
    },
    pattern: {
      type: Object,
      default: () => {
        return {
          showTopBorder: false,
          showRightBorder: false,
          showBottomBorder: true,
          showLeftBorder: false,
          showTopPadding: false,
          showRightPadding: false,
          showBottomPadding: false,
          showLeftPadding: false,
          showBorderRadius: false,
          boxType: 'block',
          circle: true
        }
      }
    },
  },
  data () {
    return {
    };
  },
  mounted () {
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.content {
  position: relative;
}
.controls {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
}
.play {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
video {
  width: 100%;
  display: block;
}
</style>
